import { render, staticRenderFns } from "./stock_detail_online_selector.vue?vue&type=template&id=514e1da2&scoped=true"
import script from "./stock_detail_online_selector.vue?vue&type=script&lang=js"
export * from "./stock_detail_online_selector.vue?vue&type=script&lang=js"
import style0 from "./stock_detail_online_selector.vue?vue&type=style&index=0&id=514e1da2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514e1da2",
  null
  
)

export default component.exports